import RestApi, { childServiceBaseUrl } from '../config/api_config'

export default {
  computed: {
    hasDropdownLoadedChild () {
      return this.$store.state.ChildService.commonObj.hasDropdownLoaded
    }
  },
  watch: {
    hasDropdownLoadedChild: function (newValue) {
      if (!newValue) {
        this.loadDropdownChildService()
      }
    }
  },
  created () {
    const hasDropdownLoadedChild = this.$store.state.ChildService.hasDropdownLoaded
    if (!hasDropdownLoadedChild || window.performance) {
    }
    this.loadDropdownChildService()
  },
  methods: {
    loadDropdownChildService () {
      RestApi.getData(childServiceBaseUrl, 'child-common-dropdowns', null).then(response => {
        if (response.success) {
          this.$store.dispatch('ChildService/mutateCommonObj', {
            hasDropdownLoaded: true,
            committeeTypList: response.data.committeeTypList,
            rehabilitationTypeList: response.data.rehabilitationTypeList,
            classList: response.data.classList,
            schoolList: response.data.schoolList,
            examTypeList: response.data.examTypeList,
            committeeNameList: response.data.committeeNameList,
            committeeDesignationList: response.data.committeeDesignationList,
            evaluationSettingList: response.data.evaluationSettingList,
            courseList: response.data.courseList,
            instructorList: response.data.instructorList,
            caseTypeList: response.data.caseTypeList,
            foodList: response.data.foodList
          })
          this.$store.dispatch('ChildService/localizeCommonDropdown', { value: this.$i18n.locale })
        }
      })
    }
  }
}
